import { IResource } from "@gettactic/api";
import { ResourceType } from "../../../api";
import { mapToRange } from "../strings/mapToRange";

export const resourcesDefaultImages: Partial<Record<ResourceType, string[]>> = {
  desk: [
    "https://cdn.gettactic.com/images/default/desk.png",
    "https://cdn.gettactic.com/images/default/desk_1.png",
    "https://cdn.gettactic.com/images/default/desk_2.png",
    "https://cdn.gettactic.com/images/default/desk_3.png",
    "https://cdn.gettactic.com/images/default/desk_4.png"
  ],
  meeting_room: [
    "https://cdn.gettactic.com/images/default/room.png",
    "https://cdn.gettactic.com/images/default/room_1.png",
    "https://cdn.gettactic.com/images/default/room_1.png",
    "https://cdn.gettactic.com/images/default/room_1.png",
    "https://cdn.gettactic.com/images/default/room_1.png"
  ]
};

// quality is 0-100
export const gerCroppedImageUrl = (
  imageUrl: string,
  width: number,
  height?: number,
  quality?: number
) => {
  const params = new URLSearchParams({
    trim: "0,0,0,0",
    image: imageUrl
  });
  if (width) params.set("width", String(width));
  if (height) params.set("height", String(height));
  if (quality) params.set("quality", String(quality));

  return `https://cdn.gettactic.com/image-crop/?${params.toString()}`;
};

export const getResourceCoverUrl = (
  resource: Partial<IResource>,
  width = 200,
  onlyImage = false,
  crop = true,
  height?: number,
  quality?: number
) => {
  if (!width) return undefined;
  const mediaVariants = onlyImage
    ? resource?.image_variants
    : resource?.media_variants;

  //TODO FIX THIS TYPE
  const resourceMediaOriginalUrl = (
    mediaVariants?.[0] as unknown as { original: string }
  )?.original as string | undefined;

  const url = resourceMediaOriginalUrl
    ? `${resourceMediaOriginalUrl}/w=${width}`
    : resourcesDefaultImages?.[resource.type || "desk"]?.[
        mapToRange(
          resource.id || "",
          resourcesDefaultImages?.[resource.type || "desk"]?.length || 4
        ) - 1
      ] || undefined;

  // If Cloudflare image, return as-is (no crop), otherwise you'll get a 400 error
  // w param works as expected
  if (url?.includes("imagedelivery.net")) {
    if (width) {
      return url.replace("/w=200", `/w=${width}`);
    }
    return url;
  }

  if (crop && url) {
    const croppedImage = gerCroppedImageUrl(url, width, height, quality);
    return croppedImage;
  }

  return url;
};
